import { Component, effect, input, signal } from '@angular/core';
import { Location } from '@angular/common';

export interface StepData {
  subtitle: string;
  image: string;
  action: (setStatus: (status: string) => void, nextStep: () => void, onError: (title: string, explanation: string) => void) => void;
}

@Component({
  selector: 'app-agile-login-stepper',
  imports: [],
  templateUrl: './stepper.html',
  styleUrl: './stepper.scss',
})
export class Stepper {
  status = signal("Puedes guiarte por la imagen.")
  step = signal(0);
  steps = input<StepData[]>([]);
  dots = signal("");
  errorStatus = signal(false);
  errorTitle = signal("");
  errorExplanation = signal("");

  nextStep = () => {
    const currentStep = this.step();
    if (currentStep < this.steps().length - 1) {
      this.step.set(currentStep + 1);
    }
  }

  onError = (title: string, explanation: string) => {
    this.errorStatus.set(true);
    this.errorTitle.set(title);
    this.errorExplanation.set(explanation);
  }

  setStatus = (status: string) => {
    this.status.set(status);
    this.dots.set("");
  }

  constructor(private location: Location) {
    effect(() => {
      if (this.steps().length > 0)
        this.steps()[this.step()].action(this.setStatus, this.nextStep, this.onError);
    })

    setInterval(() => {
      const dots = this.dots();
      if (dots.length < 3)
        this.dots.set(dots + ".");
      else
        this.dots.set("");
    }, 700);
  }


  back() {
    this.location.back();
  }
}
